export default [
    {
        path: 'relatorio-paciente-bairro',
        component: () => import(
            /* webpackChunkName: 'cadastro-relatorio-paciente-bairro' */
            '@/views/cadastro/relatorio-paciente-bairro/Index'
        ),
        redirect: 'relatorio-paciente-bairro/index',
        children: [
            {
                name: 'cadastro-relatorio-paciente-bairro-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-relatorio-paciente-bairro' */
                    '@/views/cadastro/relatorio-paciente-bairro/List.vue'
                ),
            },
        ],
    },
]